import ModusServiceCollection from "../ModusServiceCollection";
import ResultNutrientRecommendationElementModel from "../../models/modus/ResultNutrientRecommendationElementModel";

/**
 * ResultNutrientRecommendationElement collection
 */
export default class ResultNutrientRecommendationElementCollection extends ModusServiceCollection {

  // Model that is contained in this collection.
  model() {
    return ResultNutrientRecommendationElementModel;
  }

}
